import { render, staticRenderFns } from "./CustomDataTable.vue?vue&type=template&id=1f0570d6&scoped=true"
import script from "./CustomDataTable.vue?vue&type=script&lang=js"
export * from "./CustomDataTable.vue?vue&type=script&lang=js"
import style0 from "./CustomDataTable.vue?vue&type=style&index=0&id=1f0570d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0570d6",
  null
  
)

export default component.exports